import { useAct } from 'DashboardUser/store'
import generateFilterLookup from 'DashboardUser/lib/filterConfig'

export default function Filters() {
  const act = useAct()
  const [isExpanded, setIsExpanded] = useState(false)
  const searchText = useSel(s => s.local.filters?.searchText || '')
  const isDirty = useSel(s => s.local.isDirty)
  const savedFilters = useSel(s => s.local.filters)
  const dashboardFields = useSel(s => _.orderBy(s.dashboard.dashboardFields, 'digitOrder', 'asc'));
  const surveyQuestions = useSel(s => s.dashboard.survey?.questions)
  const filtersAvailable = generateFilterLookup({ dashboardFields, surveyQuestions });
  const timeoutRef = useRef(null)

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    if (isDirty && !isExpanded) {
      timeoutRef.current = setTimeout(() => {
        handleSearchSubmit()
      }, 500)
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
    }
  }, [searchText, isDirty, isExpanded])

  const handleSearchKeyPress = (e) => {
    if (e.key === 'Enter') {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
      }
      handleSearchSubmit()
    }
  }

  function handleSearchSubmit() {
    act.app.reloadTargets()
    setIsExpanded(false)
  }

  function setSearchText(value) {
    act.local.setFilter('searchText', value);
  }

  return (
    <div className='filters-container'>
      <div className='main-row'>
        <div className='search-box'>
          <svg className='search-icon' fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            type="text"
            value={searchText}
            onChange={(e) => setSearchText(e.target.value)}
            onKeyPress={handleSearchKeyPress}
            placeholder="Search members..."
          />
        </div>
        <div className='more-button' onClick={() => setIsExpanded(!isExpanded)}>
          More filters {isExpanded ? '▲' : '▼'}
          {!isExpanded && savedFilters?.length > 0 && (
            <span className='indicator-dot'></span>
          )}
        </div>
      </div>

      {!isExpanded && <FilterPills filters={filtersAvailable} />}

      {isExpanded && <ExpandedFilters filters={filtersAvailable} handleSearchSubmit={handleSearchSubmit} />}
    </div>
  )
}

function FilterPills({ filters }) {
  const act = useAct()
  const submittedFilters = useSel(s => s.local.submittedFilters);
  function clearFilter(key) {
    act.local.setFilter(key, null);
    act.app.reloadTargets()
  }

  return <div className='filter-pills'>
    {_.map(submittedFilters, (value, key) => {
      const Pill = filters[key]?.pill;
      return <Pill value={value} onClear={() => clearFilter(key)} />;
    })}
  </div>
}

export function FilterPill({ onClear, children}) {
    return <div className='pill'>
        {children}
        <button className='pill-close' onClick={onClear}>×</button>
    </div>
}

function ExpandedFilters({ filters, handleSearchSubmit }) {
  return (
    <div className='expanded-filters'>
      {Object.values(filters).filter(f => f.filter).map(({ filter }, index) => (
        <div className='filter-row' key={index}>
          {filter()}
        </div>
      ))}
      <div className='confirm-row'>
        <button className='button primary' onClick={handleSearchSubmit}>Apply Filters</button>
      </div>
    </div>
  )
}
